import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useApplicantCheck = () => {
  const [isApplicant, setIsApplicant] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);
  const [profileId, setProfileId] = useState<string | null>(null);

  useEffect(() => {
    const checkApplicant = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session?.user) {
          setIsApplicant(false);
          setIsLoading(false);
          return;
        }

        // Get user's profile
        const { data: profile } = await supabase
          .from('profiles')
          .select('id')
          .eq('user_id', session.user.id)
          .single();

        if (profile) {
          setProfileId(profile.id);
          
          // Check if user has any applications
          const { data: applications } = await supabase
            .from('applications')
            .select('id')
            .eq('profile_id', profile.id)
            .limit(1);

          setIsApplicant(!!applications && applications.length > 0);
        }
      } catch (error) {
        console.error('Error checking applicant status:', error);
        setIsApplicant(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkApplicant();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkApplicant();
    });

    return () => subscription.unsubscribe();
  }, []);

  return { isApplicant, isLoading, profileId };
};
